import React from "react";
import { GET_ARTICLE } from "../hooks/useArticle";
import Four0Four from "./404";
import Block from "../components/blocks";
import Meta from "../components/meta";
import { Store } from "../store";
import useResponsive from "../hooks/useResponsive";
import { useQuery } from "@apollo/client";
import { findUrlForMediaArray } from "../utils";

const Article = ({ handle, isHomepage }) => {
  const config = Store.useState(s => s.config);
  const settings = config.eshop.theme.selected.settings;
  const { isMobile } = useResponsive({ maxWidth: settings?.mobileBreakpoint });

  const { data, loading } = useQuery(GET_ARTICLE, { variables: { handle } });

  if (loading || (data && data.article === undefined)) return null;
  else if (!data?.article) return <Four0Four />;

  const article = data.article;

  return (
    <div id="article" className={`${isHomepage ? "homepage" : ""} ${article.handle.replace("/", "")}`}>
      <Meta
        path={article.path}
        description={article.seo.description || article.title}
        index={article.seo.index}
        title={isHomepage ? null : article.title}
        updated={article.modified}
        image={findUrlForMediaArray(article.thumbnail)}
      />
      {data.article.content.rows.map(r => (
        <div key={r.id} className={`row ${isMobile ? "mobile" : ""} ${r.layout} ${r.options && r.options.fullWidth ? "fullWidth " : ""} ${r.options && r.options.noPadding ? "noPadding " : ""}`}>
          {r.columns.map(c => (
            <div key={c.id} className="column">
              {c.blocks.map(b => (
                <Block key={b.id} block={b} />
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

const Routes = ({ articles, homepage }) => {
  const routes = articles.map(a => ({ path: a.handle, element: <Article handle={a.handle} /> }));
  if (homepage?.type === "article") routes.push({ path: "/", element: <Article handle={homepage.handle} isHomepage={true} /> });

  return routes;
};

export default Article;
export { Routes };
